const createQueryString = (value: any) => {
  return Object.keys(value)
    .map(key => `${key}=${value[key]}`)
    .join('&')
}

export default createQueryString
